import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import familyConfig from '../../familyConfig';

@customElement('family-select')
export class FamilySelect extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}
			.link {
				color: #fff;
			}
			.values {
				display: flex;
				flex-direction: column;
				overflow-y: scroll;
			}

			.selectedValue {
				color: var(--color-text-widget-value);
				font-size: var(--font-size-widget-small);
				margin-left: auto;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
			a {
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: transparent;
				display: inline-block;
				cursor: pointer;
				white-space: nowrap;
				transition: background-color 0.4s, color 0.4s;
				padding: 8px 16px;
				text-align: center;
				border: 0 none;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
				text-decoration: none;
			}

			a:hover {
				background-color: var(--color-widget-background-hover);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.loggedIn = state.userProfile.data.loggedIn;

		// convert familyConfig object to array with id as index
		const families = [];
		Object.keys(familyConfig).forEach( (key) => {
			const family = { ... familyConfig[key] };
			family.id = key;
			families.push(family);
		});
		this.families = families.sort((a, b) => a.id.localeCompare(b.id));
	}


	render() {
		if (!this.loggedIn || !this.families || this.families.length === 0) return null;

		return html`
			<div>
				<div class="title">
					Familie
				</div>
				<div class="values">
					${repeat(this.families,
							(family) => family.id,
							(family) => html`
								<a @click=${this.onClick} class="link" href="/${this.region}/${this.lang}/${family.id}">${family.id}</a>
							`)}
				</div>
			</div>

		`;
	}
}
